import { cn } from "@/lib/utils";

export const LOCALES = [
  { code: "pt-PT", label: "PT", flag: "🇵🇹" },
  { code: "pt-BR", label: "BR", flag: "🇧🇷" },
  { code: "en", label: "EN", flag: "🇬🇧" },
  { code: "es", label: "ES", flag: "🇪🇸" },
  { code: "fr", label: "FR", flag: "🇫🇷" },
  { code: "it", label: "IT", flag: "🇮🇹" },
] as const;

export type LocaleCode = typeof LOCALES[number]["code"];

interface Props {
  value: LocaleCode;
  onChange: (v: LocaleCode) => void;
  className?: string;
}

const LocaleTabs = ({ value, onChange, className }: Props) => (
  <div className={cn("inline-flex gap-1 p-1 bg-muted rounded-xl", className)}>
    {LOCALES.map((l) => (
      <button
        key={l.code}
        onClick={() => onChange(l.code)}
        className={cn(
          "px-3 py-1.5 text-xs font-semibold rounded-lg transition-colors flex items-center gap-1.5",
          value === l.code
            ? "bg-background text-foreground shadow-sm"
            : "text-muted-foreground hover:text-foreground"
        )}
        type="button"
      >
        <span>{l.flag}</span>
        <span>{l.label}</span>
        {l.code === "pt-PT" && (
          <span className="text-[10px] text-muted-foreground/70">base</span>
        )}
      </button>
    ))}
  </div>
);

export const storageKeyFor = (fieldKey: string, locale: LocaleCode) =>
  locale === "pt-PT" ? fieldKey : `${fieldKey}__${locale}`;

export default LocaleTabs;
